export enum WorkoutSource {
  FromSchedule = "fromSchedule",
  FromException = "fromException",
  FromActivity = "fromActivity",
}
